




































import vue from 'vue';
import {
  VNavigationDrawer,
  VDivider,
  VList,
  VListItem,
  VListItemGroup,
  VListItemIcon,
  VListItemContent,
  VListItemTitle
} from 'vuetify/lib';

interface AiDrawerItemsTypes {
  title: string;
  icon: string;
  link: string;
}

export default vue.extend({
  components: {
    VNavigationDrawer,
    VDivider,
    VList,
    VListItem,
    VListItemGroup,
    VListItemIcon,
    VListItemContent,
    VListItemTitle
  },
  props: {
    items: Array as () => AiDrawerItemsTypes[],
    width: {
      type: String,
      default: '249'
    }
  },
  data: () => ({
    selected: 0,
    drawer: null
  }),
  created() {
    this.$router.onReady(() => {
      const currentPath = this.$route.path;
      const itemIndex = this.items?.findIndex(item => item.link === currentPath);

      this.selected = itemIndex;
    });
  },
  methods: {
    handleListItemClick(index: number, path: string) {
      this.selected = index;
      this.$route.path !== path ? this.$router.push({ path }) : null;
    }
  },
  watch: {
    $route() {
      const itemIndex = this.items.findIndex(item => item.link === this.$router.currentRoute.fullPath);
      this.selected = itemIndex;
    }
  }
});
